import * as React from 'react';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { Bem, addClass } from '../../utils';
import { Icon } from '../Icon/Icon';
import { useId } from '../../utils/hooks/useId';
import './HeaderItem.css';
const bem = Bem.create('vai-header-item');
export const HeaderItem = (props) => {
    const { htmlId, dataTa, className, onClick, iconName, iconColor, title, isOpen, component = 'div', innerRef, ...rest } = props;
    const id = useId(htmlId, ['header item']);
    const hasChevron = isOpen !== undefined;
    const hasAction = onClick !== undefined;
    const classes = addClass(bem.block(hasAction && 'with-action', isOpen && 'active'), className);
    const Component = component;
    return (React.createElement(Component, Object.assign({ id: id.toString(), "data-ta": dataTa, className: classes, onClick: onClick, ref: innerRef }, rest),
        React.createElement(Icon, { htmlId: id.toHtmlId(), className: bem.element('icon')(), name: iconName, color: iconColor }),
        title && (React.createElement("span", { id: id.copyWith(['title']).toString(), className: bem.element('title')() }, title)),
        hasChevron && React.createElement(Icon, { className: bem.element('icon-chevron')(), name: isOpen ? VaiIcon.ChevronUp : VaiIcon.ChevronDown })));
};
//# sourceMappingURL=HeaderItem.js.map